import React, { useState, useEffect } from 'react';
import './NodeUsage.css';

import Updatedtime from '../UpdatedTime/Updatedtime';
import Dropdown from './NodeDropbox';
import Table from './NodeTable';
import NodeDownload from './NodeDownload';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function NodeUsage() {
  const [selectedClusters, setSelectedClusters] = useState([]);
  const [selectedEnvironment, setSelectedEnvironment] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [environments, setEnvironments] = useState([]);
  const [environmentData, setEnvironmentData] = useState([]);
  const [filteredEnvironmentData, setFilteredEnvironmentData] = useState([]);
  const [environmentTime, setEnvironmentTime] = useState('');  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleEnvironmentSelect = (env) => {
    setSelectedEnvironment(env);
    setSelectedClusters([]);
  };

  const handleClusterSelect = (clusters) => {
    console.log("Selected clusters in NodeUsage:", clusters);
    setSelectedClusters(clusters);
  };

  // Filter environment data based on selected clusters
  useEffect(() => {
    if (!environmentData || environmentData.length === 0) {
      setFilteredEnvironmentData([]);
      return;
    }

    let filteredData = [...environmentData];
    
    // Apply cluster filter if any clusters are selected
    if (selectedClusters && selectedClusters.length > 0) {
      filteredData = filteredData.filter(item => 
        selectedClusters.includes(item.cluster)
      );
    }
    
    setFilteredEnvironmentData(filteredData);
  }, [environmentData, selectedClusters]);

  // Fetch all environments name
  useEffect(() => {
    const fetchEnv = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/inventory/all-envs`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Initial fetch response:', data);             
            
        setEnvironments(data.data || []);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEnv();
  }, []);

  // Fetch environment data when the environment changes
  useEffect(() => {
    if (!selectedEnvironment) {
      setEnvironmentData([]);
      setFilteredEnvironmentData([]);
      setEnvironmentTime('');
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/inventory/nodes/combined/${selectedEnvironment}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Fetch environment data response:', data);             
        
        if (data.date_time === undefined) {
          console.warn('No date_time in response for:', selectedEnvironment);
        }
        
        const newData = data.data || [];
        setEnvironmentData(newData);
        setFilteredEnvironmentData(newData); // Initialize with all data
        if (data.date_time) {
          setEnvironmentTime(data.date_time);
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedEnvironment]);

  const refreshEnv = async () => {
    if (!selectedEnvironment) {
      return;
    }

    setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/inventory/nodes/combined/${selectedEnvironment}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Fetch environment data response:', data);             
        
        if (data.date_time === undefined) {
          console.warn('No date_time in response for:', selectedEnvironment);
        }
        
        const newData = data.data || [];
        setEnvironmentData(newData);
        setFilteredEnvironmentData(newData); // Initialize with all data
        if (data.date_time) {
          setEnvironmentTime(data.date_time);
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
  };
  
  return (
    <div>
      <div className="node-content-container">
        <div className="node-time-container">
          <Updatedtime 
            environmentTime={environmentTime} 
            loading={loading}
            error={error}
          />
          <button 
            onClick={refreshEnv} 
            className="node-refresh-button"
            data-tooltip="Refresh"
            disabled={!selectedEnvironment || loading}
          >
            ↻
          </button>
          <NodeDownload 
            environmentData={filteredEnvironmentData}
            selectedEnvironment={selectedEnvironment}
            selectedClusters={selectedClusters}
            environmentTime={environmentTime} 
          />
        </div>
        
        <div className='node-dropbox-table'>
          <div className="node-dropbox-container">
            <Dropdown
              onSearch={handleSearch}
              onSelectEnvironment={handleEnvironmentSelect}
              onSelectCluster={handleClusterSelect}
              environments={environments}
              selectedClusters={selectedClusters}
              environmentData={environmentData}
            />
          </div>
          
          <div className="node-table-container">
            <Table
              searchTerm={searchTerm}
              selectedClusters={selectedClusters}
              selectedEnvironment={selectedEnvironment}
              environmentData={filteredEnvironmentData}
              loading={loading}
              error={error}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NodeUsage;